export default class PopupUSA {
    static init() {
        const url = document.location;
        const req = new XMLHttpRequest();
        req.open('HEAD', url, false);
        req.send(null);
        const headerStr = req.getAllResponseHeaders();
        const headers = this.parseHeaders(headerStr);

        const ipIsUSA = headers['x-location-usa'];
        if (ipIsUSA) {
            this.showPopup();
            this.initClosePopup();
        }

    }

    static parseHeaders(headerStr) {
        const headers = {};
        const lines = headerStr.trim().split(/[\r\n]+/);
        lines.forEach(line => {
            const parts = line.split(': ');
            const key = parts.shift().toLowerCase(); // en minuscule pour uniformiser
            const value = parts.join(': ');
            headers[key] = value;
        });
        return headers;
    }

    static showPopup() {
        const popup = document.querySelector('.popup-usa-visitors');

        // Vérifie si le cookie "popop_usa_closed" est absent
        const cookieExists = document.cookie.split('; ').some(c => c.startsWith('popup_usa_closed='));

        if (!cookieExists && popup) {
            popup.classList.add('show-popup');
        }
    }

    static initClosePopup() {
        const popup = document.querySelector('.popup-usa-visitors');
        const closeBtn = document.querySelector('.popup-usa-visitors .close-popup');
        if (closeBtn && popup) {
            closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                popup.classList.remove('show-popup');
                const expires = new Date();
                expires.setHours(expires.getHours() + 24);
                document.cookie = `popup_usa_closed=1; expires=${expires.toUTCString()}; path=/`;
            });
        }
    }
}
